<script lang="ts">
  import { Button, ButtonDropdown } from '$shared/components';
  import Label from '$shared/constants/Label';
  import { getSanctionReviewActionAsList } from '$shared/constants/SanctionReviewActionType';
import { ButtonStyle } from '$shared/constants/ButtonStyle';

  const MatchFound = 'Match Found';

  interface Props {
    processing?: boolean;
    disabled?: boolean;
    onreject?: () => void;
    onevent?: (payload: any) => void;
    onapprove?: () => void;
  }

  let { processing = false, disabled = false, onreject, onevent, onapprove }: Props = $props();

  const onClickReject = (): void => {
    onreject?.();
  };

  const onClickButtonItem = (item: CommonList): void => {
    onevent?.(item.id);
  };

  const onClickApprove = (): void => {
    onapprove?.();
  };
</script>

<div data-cy="match-found-banner" class="match-found-review-banner">
  <div data-cy="match-found-label" class="label">{MatchFound}</div>
  <div class="action">
    <ButtonDropdown
      loading={processing}
      disabled={processing || disabled}
      options={{
        list: getSanctionReviewActionAsList(),
        icon: 'icon-x',
        name: 'rejectMatch'
      }}
      onclick={onClickReject}
      onclickitem={onClickButtonItem}
    >
      {Label.Reject}
    </ButtonDropdown>
    <div class="confirm-action">
      <Button
        loading={processing}
        disabled={processing || disabled}
        name="acceptMatch"
        style={ButtonStyle.Primary}
        icon="icon-check"
        onclick={onClickApprove}
      >
        {Label.Accept}
      </Button>
    </div>
  </div>
</div>

<style>
  .match-found-review-banner {
    display: flex;
    justify-content: space-between;
    padding: 8px;
    background-color: var(--yellow);
  }
  .match-found-review-banner .label {
    display: flex;
    align-items: center;
    font-weight: 600;
    font-size: 14px;
    padding-left: 16px;
  }
  .match-found-review-banner .action {
    display: inline-flex;
    padding-right: 16px;
  }
  .match-found-review-banner .action .confirm-action {
    margin-left: 16px;
  }
</style>
